import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { buttonGroupColors } from "components/VetExamOverlay/options";
import { IButtonGroup } from "components/ButtonsGroup/ButtonsGroup";

export const TRACK_OPTICS_INJURY_ENTRY_UNUSABLE_ID =
  "b82451a2-854c-4eb7-8413-63343339db05";
export const TRACK_OPTICS_INJURY_ENTRY_NONE_ID =
  "0306d136-c97b-4e13-8c26-f3c21346dce7";
export const TRACK_OPTICS_INJURY_ENTRY_FRONT_LIMBS_ID =
  "1f755daf-8995-45fb-9234-676bd5b8f50f";
export const TRACK_OPTICS_INJURY_ENTRY_REAR_LIMBS_ID =
  "d8f60368-4c07-4caa-bf70-014ec6a39eda";

type TrackOpticsEntry = {
  id?: string | null;
  description?: string | null;
};

type TFormFields = (
  | racehorse360.ITrackOpticsVideoInjuryEntry
  | racehorse360.ITrackOpticsVideoLimb
  | racehorse360.ITrackOpticsVideoStride
)[];

export const mapFormFields = (list: TFormFields): TrackOpticsEntry[] => {
  if (!list?.length) return [];

  list.sort((i1, i2) => i2.description.localeCompare(i1.description));

  return list.reduce((acc, cur) => {
    return cur.description === "None" ? [...acc, cur] : [cur, ...acc];
  }, []);
};

export interface IField {
  key: string;
  label: string;
  entries: TrackOpticsEntry[];
  value: string;
  shouldRender: boolean;
}

export enum WorkoutAnalysisFormField {
  HORSE_NAME_OR_REGISTRATION_NUMBER = "horseNameOrRegistrationNumber",
  INJURY_ENTRY_ID = "injuryEntryId",
  LIMB_ID = "limbId",
  STRIDE_ID = "strideId",
  INJURY_SEVERITY_ID = "injurySeverityId",
  COMMENT = "comment"
}

export interface IWorkoutAnalysisFormState {
  horseNameOrRegistrationNumber: string;
  injuryEntryId: string;
  limbId: string;
  strideId: string;
  injurySeverityId: string;
  comment: string;
}

interface IChangeEntryAction {
  type: WorkoutAnalysisFormField;
  payload: string;
}

export const initialState: IWorkoutAnalysisFormState = {
  horseNameOrRegistrationNumber: "",
  injuryEntryId: "",
  limbId: "",
  strideId: "",
  injurySeverityId: "",
  comment: ""
};

export const changeWorkoutAnalysisFormValueReducer = (
  state: IWorkoutAnalysisFormState,
  action: IChangeEntryAction
): IWorkoutAnalysisFormState => {
  const { type, payload } = action;
  const isNonLimbValue = [
    TRACK_OPTICS_INJURY_ENTRY_UNUSABLE_ID,
    TRACK_OPTICS_INJURY_ENTRY_NONE_ID
  ].includes(payload);

  const payloadState = isNonLimbValue ? initialState : state;
  switch (type) {
    case WorkoutAnalysisFormField.INJURY_ENTRY_ID:
      return {
        ...payloadState,
        injuryEntryId: payload
      };
    case WorkoutAnalysisFormField.LIMB_ID:
      return {
        ...state,
        limbId: payload
      };
    case WorkoutAnalysisFormField.STRIDE_ID:
      return {
        ...state,
        strideId: payload
      };
    case WorkoutAnalysisFormField.INJURY_SEVERITY_ID:
      return {
        ...state,
        injurySeverityId: payload
      };
    case WorkoutAnalysisFormField.HORSE_NAME_OR_REGISTRATION_NUMBER:
      return {
        ...state,
        horseNameOrRegistrationNumber: payload
      };
    case WorkoutAnalysisFormField.COMMENT:
      return {
        ...state,
        comment: payload
      };
    default:
      return state;
  }
};

export const mapGroupButtonsOptions = (
  buttons: racehorse360.ITrackOpticsVideoInjurySeverity[]
): IButtonGroup[] => {
  return buttons
    .sort((a, b) => Number(a.value) - Number(b.value))
    .map((item, index) => ({
      ...item,
      value: item.value || 0,
      ...buttonGroupColors[index]
    })) as IButtonGroup[];
};
